
import { createApi } from '@reduxjs/toolkit/query/react';
import { createCustomFetchBaseQuery } from '../baseQuery';

export const resources = createApi({
    reducerPath: 'resources',
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ['resources'],
    endpoints: (builder) => ({
        getresources: builder.query({
            query: ({ page = 1, limit = 10 }) => `/api/resources/get-user-resources?page=${page}&limit=${limit}`,
            providesTags: (result, error, { page, limit }) => [
                { type: 'resources', id: `page-${page}-limit-${limit}` },
            ],
        }),

        createresources: builder.mutation({
            query: (data) => ({
                url: `/api/resources/create-new-resources`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['resources'],
        }),

        deleteresources: builder.mutation({
            query: (id) => ({
                url: `/api/resources/delete-resources/${id}`,  // Send the `id` as a query parameter
                method: 'DELETE',  // Or DELETE if your backend expects DELETE
            }),
            invalidatesTags: ['resources'],
        }),


        updateresources: builder.mutation({
            query: (data) => ({
                url: `/api/resources/update-resources`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['resources'],
        }),
    }),
});

export const {
    useGetresourcesQuery,
    useCreateresourcesMutation,
    useDeleteresourcesMutation,
    useUpdateresourcesMutation
} = resources;